import { GlobalSetting, GlobalSettingProvider } from '../../domain/usdt-providers/globalSettingProvider';
import { Button, Card, Form, Input, InputNumber, Modal, PageHeader, Select, Spin, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { Content } from 'antd/lib/layout/layout';
import _module from '../configs/module';
import { WRITE_SYSTEM_SETTING } from '../configs/scopes';
import { CRotationPairEditor } from '../components/CRotationPairEditor';
import ProForm from '@ant-design/pro-form';

const inputStyle: React.CSSProperties = { width: 360 };

const GlobalSettingManager = (props: { title: string }) => {
  const [form] = ProForm.useForm<GlobalSetting>();
  const [formState, setFormState] = useState<{ loading: boolean }>({
    loading: true,
  });

  const handleSubmit = async () => {
    const data = await form.validateFields();
    delete data.ETH_TO_USDT_RATE;
    delete data.ETH_TO_USDT_RATE;
    await GlobalSettingProvider.put(data)
      .then((res) => {
        Modal.success({
          content: '更新成功',
          okText: '確認',
        });
      })
      .catch((e) => console.error(e));
  };

  useEffect(() => {
    GlobalSettingProvider.get().then((data) => {
      const setting = data.data;
      form.setFieldsValue(setting);
      setFormState({ loading: false });
    });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <PageHeader title={props.title} subTitle="" extra={<></>} />
      <Spin spinning={formState.loading}>
        <Content
          style={{
            padding: 24,
            margin: 0,
          }}
        >
          <Form
            form={form}
            name="register"
            scrollToFirstError
            onFinish={handleSubmit}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 16 }}
          >
            <Card title="匯率設定" style={{ marginBottom: 16 }}>
              <Form.Item
                name="CUSTOM_EXCHANGE_RATE"
                label="使用自定義匯率"
                valuePropName="checked"
                rules={[{ required: true }]}
              >
                <Switch />
              </Form.Item>
              <Form.Item
                name="CNY_TO_USDT_BUY_PRICE"
                label="CNY買入價"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={6}
                  max={7}
                  precision={4}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="CNY_TO_USDT_SELL_PRICE"
                label="CNY賣出價"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={6}
                  max={7}
                  precision={4}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
            </Card>
            <Card title="出款費率設定" style={{ marginBottom: 16 }}>
              <Form.Item
                name="ETH_TO_USDT_RATE"
                label="乙太到 Usdt 費率"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="TRANSFER_THRESHOLD_RATE"
                label="手續費佔轉帳金額百分比"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="TRX_TO_USDT_RATE"
                label="波場到 Usdt 費率"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="SOL_TO_USDT_RATE"
                label="SOL到 Usdt 費率"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="BNB_TO_USDT_RATE"
                label="BNB到 Usdt 費率"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="BNB_TO_USDC_RATE"
                label="BNB到 Usdc 費率"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="BNB_TO_BUSD_RATE"
                label="BNB到 Busd 費率"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
            </Card>
            <Card title="傭金提領設定" style={{ marginBottom: 16 }}>
              <Form.Item
                name="AGENTFUNDING_ETH_FEE"
                label="ERC提領佣金網路費用(USDT)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="AGENTFUNDING_TRX_FEE"
                label="TRC提領佣金網路費用(USDT)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="AGENTFUNDING_SOL_FEE"
                label="SOL提領佣金網路費用(USDT)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="AGENTFUNDING_BNB_FEE"
                label="BNB提領佣金網路費用(USDT)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
            </Card>
            <Card title="輪詢自動歸集模式設定" style={{ marginBottom: 16 }}>
              <Form.Item
                name="AUTO_COLLECT_POLLING_TRX_MIN"
                label="輪詢錢包TRX最小值"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="AUTO_COLLECT_POLLING_TRX_DEPOSIT_AMOUNT"
                label="不足時補充TRX數量"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="AUTO_COLLECT_POLLING_USDT_THRESHOLD"
                label="USDT自動歸集門檻"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
            </Card>
            <Card title="ETH設定" style={{ marginBottom: 16 }}>
              <Form.Item
                name="ETH_COLLECT_BUFFER_AMOUNT"
                label="歸集ETH緩衝金額"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  max={0.005}
                  step={0.0001}
                  precision={6}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="ETH_ESTIMATE_NETWORK_FEE"
                label="乙太代付下發預估礦工費"
                tooltip="此設定值由系統自動更新"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  precision={6}
                  readOnly={true}
                />
              </Form.Item>
            </Card>
            <Card title="代付/下發限額" style={{ marginBottom: 16 }}>
              <Form.Item
                name="PAYFOR_MAX_AMOUNT"
                label="單筆最高限額(USDT)"
                tooltip="商戶 API 代付與後台下發共用;0 或留空 = 不限制"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
            </Card>
            <Card title="商戶錢包自動補TRX機制" style={{ marginBottom: 16 }}>
              <Form.Item
                name="AUTO_MCH_WALLET_TRX_MIN"
                label="商戶錢包TRX最小值"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="AUTO_MCH_WALLET_TRX_DEPOSIT_AMOUNT"
                label="不足時補充TRX數量"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
            </Card>
            <Card title="充值匹配錯誤防範機制" style={{ marginBottom: 16 }}>
              <Form.Item
                name="LOCK_BSC_USD_DEPOSIT_AMOUNT_THRESHOLD"
                label="鎖定充值金額門檻(BSC-USDT,USDC,BUSD)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="LOCK_BSC_USD_FLOATING_AMOUNT"
                label="鎖定充值上下金額(BSC-USDT,USDC,BUSD)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="LOCK_ERC_USDT_DEPOSIT_AMOUNT_THRESHOLD"
                label="鎖定充值金額門檻(ERC-USDT)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="LOCK_ERC_USDT_FLOATING_AMOUNT"
                label="鎖定充值上下金額(ERC-USDT)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="LOCK_TRC_USDT_DEPOSIT_AMOUNT_THRESHOLD"
                label="鎖定充值金額門檻(TRC-USDT)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="LOCK_TRC_USDT_FLOATING_AMOUNT"
                label="鎖定充值上下金額(TRC-USDT)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="LOCK_SOLANA_USDT_DEPOSIT_AMOUNT_THRESHOLD"
                label="鎖定充值金額門檻(SOLANA-USDT)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="LOCK_SOLANA_USDT_FLOATING_AMOUNT"
                label="鎖定充值上下金額(SOLANA-USDT)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="LOCK_ERC_ETH_DEPOSIT_AMOUNT_THRESHOLD"
                label="鎖定充值金額門檻(ERC-ETH)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="LOCK_ERC_ETH_FLOATING_AMOUNT"
                label="鎖定充值上下金額(ERC-ETH)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={6}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="LOCK_XRP_XRP_DEPOSIT_AMOUNT_THRESHOLD"
                label="鎖定充值金額門檻(XRP-XRP)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="LOCK_XRP_XRP_FLOATING_AMOUNT"
                label="鎖定充值上下金額(XRP-XRP)"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
            </Card>
            <Card title="能量來源設定" style={{ marginBottom: 16 }}>
              <Form.Item
                name="PAYOUT_ENERGY_METHOD"
                label="出款能量方式"
                tooltip="A=租用錢包(TWgJyC)委派能量,不足門檻退Tronify；B=Tronify；C=0.1TRX轉帳即租；D=转账即租(固定provider),沒回能量退Tronify"
                rules={[{ required: true }]}
              >
                <Select
                  style={{ ...inputStyle }}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                  options={[
                    { value: 'A', label: 'A（租用錢包自委派，不足退Tronify）' },
                    { value: 'B', label: 'B（Tronify）' },
                    { value: 'C', label: 'C（0.1TRX 轉帳即租）' },
                    { value: 'D', label: 'D（转账即租-固定TFGtW）' },
                  ]}
                />
              </Form.Item>
              <Form.Item
                name="PAYOUT_HALTED"
                label="出款暫停"
                valuePropName="checked"
                tooltip="C 拿不到能量時系統會自動設為開；恢復請改用 B 或手動關閉"
              >
                <Switch disabled={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item
                name="COLLECT_ENERGY_THRESHOLD"
                label="運營錢包能量門檻(%)"
                tooltip="運營錢包(TWgJyC)剩餘能量% ≥ 門檻:歸集/出款走自委派(A)；低於:走 Tronify(B)。歸集與出款共用此門檻"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  max={100}
                  precision={0}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="COLLECT_C_ENABLED"
                label="歸集0.01開關"
                valuePropName="checked"
              >
                <Switch disabled={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item name="COLLECT_C_MIN_TRX" label="歸集0.01最低TRX">
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="COLLECT_USER_USDT_MIN"
                label="用戶錢包USDT歸集門檻"
                tooltip="用戶錢包 USDT 餘額 > 此值才歸集(poke-jobs)。空/未設則用程式常數 1900。"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="COLLECT_MCH_USDT_MIN"
                label="商戶錢包USDT歸集門檻"
                tooltip="商戶錢包 USDT 餘額 > 此值才歸集(poke-jobs)。空/未設則用程式常數 50。"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="COLLECT_E_ENABLED"
                label="歸集方式E開關"
                tooltip="開啟後,歸集在送 0.01(C)之前先試方式 E:呼叫 tg-miniapp-poc /initdata 委派能量。需另設 E_API_URL / E_API_TOKEN,否則 E 會靜默跳過、退回 C(等於沒開)。"
                valuePropName="checked"
              >
                <Switch disabled={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item
                name="COLLECT_E_MIN_ENERGY"
                label="E 逾時能量門檻"
                tooltip="方式 E 委派逾時後,回頭查入金錢包能量:達到這個值就判定「E 已生效、跳過 C」;沒達到才照原邏輯送 0.01 租能量(C)"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="E_CONFIRM_TIMEOUT_SEC"
                label="E 到帳輪詢逾時(秒)"
                tooltip="方式 E 呼叫 initdata 委派後,輪詢入金錢包能量到帳的逾時秒數;逾時未到就退回 C。預設 40。"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={1}
                  precision={0}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="COLLECT_C_BANDWIDTH_ENABLED"
                label="歸集0.01借帶寬"
                tooltip="送 0.01 前先跟運營錢包(RENTAL)借 350 帶寬,送完立刻歸還。不借的話入金錢包要自付約 0.267 TRX 手續費 —— 是那 0.01 的 27 倍。RENTAL 帶寬低於「RENTAL 帶寬地板」時會自動不借,改成自己燒,不會因此歸集失敗"
                valuePropName="checked"
              >
                <Switch disabled={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item name="FILL_TRX_AMOUNT" label="補TRX數量">
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="PAYOUT_C_INTERVAL_MIN"
                label="出款C間隔(分)"
                tooltip="出款嘗試 0.01TRX(C) 租能量的最小間隔分鐘;間隔內的出款走能量錢包(A)或Tronify(B)判斷。預設 10"
                rules={[{ required: true }]}
              >
                <InputNumber style={{ ...inputStyle }} disabled={!_module.can([WRITE_SYSTEM_SETTING])} min={1} />
              </Form.Item>
              <CRotationPairEditor
                form={form}
                receiversField="C_ROTATION_RECEIVERS"
                amountsField="C_ROTATION_AMOUNTS"
                label="C 輪替名單(歸集用)"
                tooltip="歸集固定用這組;每列一個收款地址 + 金額,依序輪替(出款專用留空時 fallback 用這組)。每列地址金額成對,不會再有長度對不齊的問題。"
                readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
              />
              <CRotationPairEditor
                form={form}
                receiversField="PAYOUT_C_ROTATION_RECEIVERS"
                amountsField="PAYOUT_C_ROTATION_AMOUNTS"
                label="出款專用 C 輪替名單"
                tooltip="只作用於出款。整個清空(0 列)= 沿用上面歸集那組。每列地址+金額成對,不會再有長度對不齊導致出款 C 靜默停用。用來把出款成功率低的地址從出款移除、歸集仍保留。"
                readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
              />
              <Form.Item
                name="PAYOUT_C_PICK_MODE"
                label="出款C挑選模式"
                tooltip="出款 C 從輪替名單挑 receiver 的方式。隨機=每次亂數挑;順序輪詢=用 Redis 游標依名單順序均攤(命中跳過名單自動往下走,Redis 不通時自動退回隨機)。"
                rules={[{ required: true }]}
              >
                <Select
                  style={{ ...inputStyle }}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                  options={[
                    { value: 'random', label: '隨機（預設）' },
                    { value: 'round_robin', label: '順序輪詢（Redis 游標均攤）' },
                  ]}
                />
              </Form.Item>
              <Form.Item
                name="C_CONFIRM_TIMEOUT_SEC"
                label="C 能量到帳輪詢秒數"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={1}
                  precision={0}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="PAYOUT_C2_ENABLED"
                label="出款C2開關"
                tooltip="C 拿不到能量(或還在冷卻中)時,再送一次 0.01 到下面的 C2 專用地址。實測「同一輪再送一次通常會成功」。順序:C → C2 → A → D → B。C2 地址留空的話,這個開關開了也不會啟動"
                valuePropName="checked"
              >
                <Switch disabled={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item
                name="C2_RECEIVER"
                label="C2 專用收款地址"
                tooltip="單一地址,不走輪替名單。清空 = 停用 C2"
              >
                <Input style={{ ...inputStyle }} readOnly={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item name="C2_AMOUNT" label="C2 金額(TRX)">
                <InputNumber style={{ ...inputStyle }} min={0} readOnly={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item
                name="PAYOUT_D_ENABLED"
                label="出款D開關"
                tooltip="關掉的話能量鏈跳過 D,變成 C → C2 → A → B。D 是送 2/4 TRX 給固定供應商租能量,連續失敗 3 次會自動斷路 10 分鐘"
                valuePropName="checked"
              >
                <Switch disabled={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item
                name="PAYOUT_TRX_TOPUP_BELOW"
                label="出款錢包補TRX門檻"
                tooltip="出款錢包 TRX 低於這個值,自動從 RENTAL 撥款過去。0 = 不自動補"
              >
                <InputNumber style={{ ...inputStyle }} min={0} readOnly={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item name="PAYOUT_TRX_TOPUP_AMOUNT" label="出款錢包補TRX金額">
                <InputNumber style={{ ...inputStyle }} min={0} readOnly={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item
                name="RENTAL_TRX_KEEP_MIN"
                label="RENTAL 最低保留TRX"
                tooltip="補款後 RENTAL 至少要留住的 TRX。撥出去會低於這個值就放棄補款並告警 —— RENTAL 自己被掏空的話,委派交易都送不出去,整條 A 會垮"
              >
                <InputNumber style={{ ...inputStyle }} min={0} readOnly={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item name="TRONIFY_ADDRESS" label="Tronify 委派地址">
                <Input
                  style={{ ...inputStyle }}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item name="TRONIFY_SOURCE" label="Tronify sourceFlag">
                <Input
                  style={{ ...inputStyle }}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item name="TRONIFY_API_KEY" label="Tronify api-key">
                <Input.Password
                  style={{ ...inputStyle }}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item name="TG_ALERT_CHATID" label="告警 Telegram chat id">
                <Input
                  style={{ ...inputStyle }}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item name="TG_ALERT_TOKEN" label="告警 Telegram token">
                <Input.Password
                  style={{ ...inputStyle }}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item name="D_RENTAL_ADDRESS" label="D租能量地址（空=停用D）">
                <Input
                  style={{ ...inputStyle }}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item name="D_RENTAL_TRX_LOW" label="D低檔TRX(≤65000能量)">
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  step={0.1}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item name="D_RENTAL_TRX_HIGH" label="D高檔TRX(>65000能量)">
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  step={0.1}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item name="D_CONFIRM_TIMEOUT_SEC" label="D能量到帳輪詢秒數">
                <InputNumber
                  style={{ ...inputStyle }}
                  min={1}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="PAYOUT_TRX_MIN_ALERT"
                label="出款錢包TRX告警門檻"
                tooltip="出款錢包 TRX 低於此門檻時立即發 TG 告警(每錢包30分節流)；10分鐘 cron 與每筆出款當下皆會檢查。預設 50"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="PAYOUT_MAX_BURN_TRX"
                label="出款燒TRX上限"
                tooltip="一筆出款最多可以在鏈上「買能量」燒掉多少 TRX，超過就讓訂單失敗、人員重試。缺多少能量鏈上就按 210 sun/單位賣你：完全沒備到能量 = 燒 13~27 TRX（要擋的就是這個）；差幾個單位（估算誤差）只燒 0.0002 TRX，擋掉等於白白讓訂單失敗。預設 1（≈4,760 能量，約一筆轉帳的 3.6%）"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  step={0.1}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="PAYOUT_TRX_MIN_DISABLE"
                label="出款錢包TRX停用門檻"
                tooltip="出款錢包 TRX 低於此門檻時，自動把它停用(operation_wallet.enabled=0)並發 TG 通知，下一筆出款與人員重試都不會再指派到它。低於此值連 C 的 0.01 TRX 都付不出來，C/D/B 全會失敗，重試也一樣失敗。永遠不會停用最後一個啟用中的出款錢包(改發緊急告警)。設 0 = 永不自動停用。預設 2"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="PAYOUT_UNDELEGATE_DELAY_SEC"
                label="出款委派回收延遲(秒)"
                tooltip="出款委派能量/頻寬後，隔多久回收。必須大於 30 —— vc-wallet 在發交易前寫死等 30 秒，設太短會讓回收與出款交易落在同一個區塊，能量在交易正要用它時被收回，該筆出款會自己燒 7~14 TRX 買能量。預設 120"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={40}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="C_SEND_BANDWIDTH_ENABLED"
                label="C 送 0.01 前借帶寬"
                tooltip="開啟後，送 C 的 0.01 TRX 之前先跟運營錢包借帶寬（錢包超過 240 就不借；否則只借 280 減掉目前有的差額）。TRX 轉帳本身要約 267 帶寬，沒帶寬就得燒約 0.27 TRX —— 是那筆 0.01 TRX 的 27 倍，而且每次 C 嘗試都要付（包含失敗的那約一半）。預設關閉：它會讓運營錢包多送交易，而運營帶寬本身就是稀缺資源；運營帶寬低於水位時會自動不借。"
                valuePropName="checked"
              >
                <Switch disabled={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item
                name="C_BW_WAIT_BLOCK_RATIO"
                label="出款C借帶寬等上塊比例"
                tooltip="出款 C 借帶寬時，改用「等委派交易上塊」確認的比例（0~1）。舊輪詢看帳戶資源，委派還沒上塊就會提前放行，0.01 可能跟委派擠進同一個區塊而整筆燒手續費；等上塊能根治，但委派足跡先上鏈，C 供應商可能因此拒供（2026-08-25 全量切換曾出事）。0 = 全走舊輪詢（現狀）、0.1 = 一成灰度、1 = 全量。需要先開啟「C 送 0.01 前借帶寬」才有作用，改完即時生效。"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  max={1}
                  step={0.1}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="C_RECLAIM_BANDWIDTH_ENABLED"
                label="C 轉完立刻收回帶寬"
                tooltip="開啟後，C 的 0.01 TRX 一上鏈確認，就立刻把剛借的帶寬收回，讓出款錢包的委派額度歸零。借帶寬是為了讓那筆 0.01 TRX 不要燒 0.27 TRX，但帶寬留在錢包上，C 的供應商看到錢包「有資源」就不給能量 —— 0.01 TRX 送出去了，能量卻沒回來。這兩個目標互相衝突，所以獨立一個開關，可以在線上互相比對哪個划算。需要先開啟「C 送 0.01 前借帶寬」才有作用。預設關閉。"
                valuePropName="checked"
              >
                <Switch disabled={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item
                name="RENTAL_BANDWIDTH_MIN"
                label="運營錢包頻寬水位"
                tooltip="運營錢包可用頻寬低於此值時，就不再撥頻寬給出款錢包（改讓出款自己燒約 0.345 TRX 買頻寬）。運營錢包需要自己的頻寬去送能量委派/回收交易，一旦見底每筆交易都要燒 TRX，最後連能量都委派不出去。預設 600"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="PAYOUT_SWEEP_IDLE_MIN"
                label="出款錢包閒置回收門檻(分)"
                tooltip="出款錢包閒置超過此時間，每分鐘的 sweeper 才會回收運營錢包委派給它的資源。設太短會在出款途中把能量抽走。預設 3"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={1}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
            </Card>

            <Card title="歸集目的地與出款錢包設定" style={{ marginBottom: 16 }}>
              <Form.Item
                name="COLLECT_DEST_STRATEGY"
                label="歸集目的地策略"
                rules={[{ required: true }]}
              >
                <Select
                  style={{ ...inputStyle }}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                  options={[
                    { value: 'DEFAULT', label: 'DEFAULT（單一預設）' },
                    { value: 'LOWEST_BALANCE', label: 'LOWEST_BALANCE（餘額最低）' },
                    { value: 'THRESHOLD_FILL', label: 'THRESHOLD_FILL（補低於門檻）' },
                    { value: 'ROUND_ROBIN', label: 'ROUND_ROBIN（輪替）' },
                  ]}
                />
              </Form.Item>
              <Form.Item
                name="COLLECT_DEST_THRESHOLD"
                label="歸集補款門檻(USDT)"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="PAYOUT_WALLET_MAX_BALANCE"
                label="出款錢包餘額上限(0=不限)"
              >
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  precision={2}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
            </Card>

            <Card title="預備錢包池" style={{ marginBottom: 16 }}>
              <Form.Item
                name="POOL_CLAIM_ENABLED"
                label="錢包池領用開關"
                valuePropName="checked"
              >
                <Switch disabled={!_module.can([WRITE_SYSTEM_SETTING])} />
              </Form.Item>
              <Form.Item name="POOL_TARGET" label="錢包池目標數量">
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item name="POOL_READY_MIN" label="錢包池就緒最低數量">
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item name="POOL_MINT_PER_DAY" label="每日自動補貨上限">
                <InputNumber
                  style={{ ...inputStyle }}
                  min={0}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
            </Card>

            <Card title="代付失敗處理" style={{ marginBottom: 16 }}>
              <Form.Item
                name="PAYFOR_FAIL_CALLBACK"
                label="代付失敗回調商戶"
                tooltip="關(預設)=代付失敗不回調商戶,由人員手動重試；開=回調商戶"
              >
                <Select
                  style={{ ...inputStyle }}
                  disabled={!_module.can([WRITE_SYSTEM_SETTING])}
                  options={[
                    { value: '0', label: '關（不回調，人員手動重試）' },
                    { value: '1', label: '開（回調商戶）' },
                  ]}
                />
              </Form.Item>
              <Form.Item
                name="PAYFOR_FAIL_TG_CHATID"
                label="代付失敗TG群ID(空=沿用告警群)"
              >
                <Input
                  style={{ ...inputStyle }}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
              <Form.Item
                name="PAYOUT_FAIL_TG_CHATID"
                label="出款失敗共用TG群(空=沿用告警群)"
              >
                <Input
                  style={{ ...inputStyle }}
                  readOnly={!_module.can([WRITE_SYSTEM_SETTING])}
                />
              </Form.Item>
            </Card>

            <Button
              key={1}
              type="primary"
              htmlType="submit"
              onClick={() => {}}
              loading={formState.loading}
              disabled={!_module.can([WRITE_SYSTEM_SETTING])}
            >
              {'更新'}
            </Button>
          </Form>
        </Content>
      </Spin>
    </>
  );
};

export default GlobalSettingManager;
